import { chooseObj, datePickerObj, inputObj, pickerObj } from "utils/getObjs";

const basicInformation = [
  inputObj('姓名', 'FNAME', true, true),
  inputObj('性别', 'FSEX', true, true),
  pickerObj('民族', 'FNATION', true),
  inputObj('证件类型', 'FCERCAT', true, true),
  inputObj('证件号码', 'FIDNUM', false, true),
  datePickerObj('出生日期', 'FBIRTH', true),
  pickerObj('政治面貌', 'FPOLSTAT'),
  pickerObj('学历', 'FEDUBACK', true),
  datePickerObj('毕业年月', 'FGRADTIME'),
  inputObj('毕业院校', 'FGRADSCH'),
  inputObj('专业', 'FMAJOR'),
  {
    ...chooseObj('常住地登记地类型', 'FRegisType', true),
    option: [[
      { label: '户籍地址', value: 1 },
      { label: '常住地址', value: 2 }
    ]]
  },
  pickerObj('户口性质', 'FREGIPERM', true),
  pickerObj('户籍地址', 'permanent', true, true),
  inputObj('户籍详细地址', 'FRESIDDETA', true),
  pickerObj('常住地址', 'address', true, true),
  inputObj('常住详细地址', 'FPERDETA', true),
];
// export const
const employForm = [
  pickerObj('就业类型', 'FWORKTYPE', true),
  {
    ...pickerObj('灵活就业方式', 'FFLEXIBLETYPE'),
    placeholder: '非灵活就业不选'
  },
  inputObj('手机号码', 'FPHONUM', true),
  inputObj('电子邮箱', 'FEMAIL'),
  // inputObj('原工作单位名称', 'FORGNAME'),
  inputObj('企业名称', 'FCORPNAME', true),
  // inputObj('在闽工龄', 'FWORKTIME'),
  datePickerObj('就业日期', 'FREGITIME', true),
  inputObj('就业登记日期', 'FRegTime', true, true),
  // 资料上传
  inputObj('审核资料', 'FAPPLYFILE'),
]
const other = [
  inputObj('其他事项', 'FREMARK'),
]


export const employPage1 = [
  { title: '基本信息', arr: basicInformation },
  // { title: '就业信息', arr: employForm },
  // { title: '其他', arr: other }
]

export const employPage2 = [
  { title: '就业信息', arr: employForm }
]

export const employPage3 = [
  { title: '其他', arr: other }
]
